<template>
  <MoleculeEditionProductSatellitesIncludedList
    v-if="habilitada"
    tipo="evaluacion"
  />
</template>

<script>
import configApp from '@/config'

/*
 | Evaluaciones se oculta hasta que el Droop este terminado: ademas de la pestaña, la URL directa
 | vuelve a Juedroop, para que no se pueda armar un producto con Evaluacion por la puerta de atras.
 */
export default {
  name: 'MoleculeEditionProductSatellitesIncludedEvaluacion',

  components: {
    MoleculeEditionProductSatellitesIncludedList: () =>
      import('@/components/molecules/MoleculeEditionProductSatellitesIncludedList')
  },

  computed: {
    habilitada () {
      return configApp.droopEvaluacionHabilitado === true
    }
  },

  created () {
    if (!this.habilitada) {
      this.$router.replace(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$t('mEditionMenu.product.satellitesIncluded.subject')}/${this.$t('mEditionMenu.product.satellitesIncluded.children.juedroop.subedition')}`)
    }
  }
}
</script>
